import React from 'react';
import Message from '../../components/message/Message';
import PropTypes from 'prop-types';
import {generateRoutePath} from '@epic-core/common';
import errorBg from '../../../../images/error-fg.png';
import {ErrorPage, ErrorBox, H1, H2, H3, P, StyledLink} from './Error.styles';

const Error500 = function Error500({staticContext}) {
    if (staticContext) {
        staticContext.status = 500;
    }

    return (
        <ErrorPage>
            <ErrorBox errorBg={errorBg}>
                <div>
                    <H1>500</H1>
                    <H2>
                        <Message code="epic.error.500.title1" />
                        <br />
                        <Message code="epic.error.500.title2" />
                    </H2>
                    <H3>
                        <Message code="epic.error.500.msg1" />
                    </H3>
                    <P>
                        <Message code="epic.error.500.msg2" />
                    </P>
                    <StyledLink to={generateRoutePath('/')}>
                        <Message code="epic.error.404.home" />
                    </StyledLink>
                </div>
            </ErrorBox>
        </ErrorPage>
    );
};

Error500.propTypes = {
    staticContext: PropTypes.object
};

export default Error500;
